/** Validation and payload assembly for Envío SMS (pure seam; no Vue). */

import {ENVIO_SMS_UNAVAILABLE, estadoFromSecuencia} from './envioSmsCatalogs.js';
import {normalizeEquiposAfectados} from './normalizeEquiposAfectados.js';

/**
 * Required Formulario de origen fields. Flip a row to optional later by removing it here.
 */
export const ENVIO_SMS_REQUIRED_FIELDS = [
  'short_description',
  'severity',
  'message',
  'affected_customer',
  'ticket_id',
  'sequence',
  'communication_date',
  'communication_time',
  'affected_services',
  'affected_equipment',
];

function isBlank(value) {
  if (Array.isArray(value)) return value.length === 0;
  return value === null || value === undefined || String(value).trim() === '';
}

/**
 * @returns {{ok: boolean, fieldErrors: Record<string, true>}}
 */
export function validateEnvioSmsForm(form) {
  const fieldErrors = {};

  for (const key of ENVIO_SMS_REQUIRED_FIELDS) {
    if (key === 'affected_equipment') {
      if (normalizeEquiposAfectados(form[key]) === '') {
        fieldErrors[key] = true;
      }
      continue;
    }
    if (isBlank(form[key])) {
      fieldErrors[key] = true;
    }
  }

  if (form.declare_end_impact) {
    if (isBlank(form.end_impact_date)) fieldErrors.end_impact_date = true;
    if (isBlank(form.end_impact_time)) fieldErrors.end_impact_time = true;
  }

  return {
    ok: Object.keys(fieldErrors).length === 0,
    fieldErrors,
  };
}

/**
 * Assembles the POST Envío SMS payload (English snake_case keys).
 * Call only after validateEnvioSmsForm succeeds.
 * Date and time stay as separate unambiguous parts; the server formats Takamaki text.
 */
function orUnavailable(value) {
  if (isBlank(value)) return ENVIO_SMS_UNAVAILABLE;
  return String(value).trim();
}

export function assembleEnvioSmsPayload(form) {
  const listaBlank = isBlank(form.lista_id);
  const declared = form.declare_end_impact === true;
  const oceane = String(form.oceane ?? '').trim();
  return {
    origen: form.origen,
    lista_id: listaBlank ? null : Number(form.lista_id),
    short_description: String(form.short_description).trim(),
    severity: form.severity,
    message: String(form.message).trim(),
    incident_manager: String(form.incident_manager).trim(),
    affected_customer: String(form.affected_customer).trim(),
    ticket_id: String(form.ticket_id).trim(),
    oceane: oceane || null,
    status: estadoFromSecuencia(form.sequence),
    sequence: form.sequence,
    communication_date: String(form.communication_date).trim(),
    communication_time: String(form.communication_time).trim(),
    end_impact_date: declared ? String(form.end_impact_date).trim() : null,
    end_impact_time: declared ? String(form.end_impact_time).trim() : null,
    affected_services: String(form.affected_services).trim(),
    affected_equipment: normalizeEquiposAfectados(form.affected_equipment),
    prevision: orUnavailable(form.prevision),
    province: orUnavailable(form.province),
    site: orUnavailable(form.site),
  };
}
